export default __webpack_public_path__ + "static/media/invoiceSummaryBlankSlate2.3faed421.png";